import MainApp from "../views/Main";
import NewStudy from "../views/StartPage/NewStudy";
import StartPage from "../views/StartPage/StartPage";
import LoadStudy from "../views/StartPage/LoadStudy";
import LoadParticipantReview from "../views/StartPage/LoadParticipantReview";
import Review from "../views/Review/Review";
import CreateCustomProtocol from "../views/StartPage/CreateCustomProtocol";
import LoginPage from "../views/StartPage/LoginPage";

// mainAppSectionIds represent the different left column and right column sections that can be placed in the main app view
const mainAppSectionIds = {
  locationSection: "LOCATON_SECTION",
  sampleSection: "SAMPLE_SECTION",
  resultsSection: "RESULTS_SECTION",
  studyInfoSection: "STUDY_INFO_SECTION",
  locationInfoSection: "LOCATION_INFO_SECTION",
  addNewLocationSection: "ADD_NEW_LOCATION_SECTION",
  mapSection: "MAP_SECTION",
};

const mainViewSectionCombinations = {
  studyInfoFocused: {
    orientation: "CENTER",
    columnOne: null,
    columnTwo: mainAppSectionIds.locationSection,
    columnThree: mainAppSectionIds.studyInfoSection,
    columnFour: null,
  },
  sampleFocused: {
    orientation: "CENTER",
    columnOne: null,
    columnTwo: mainAppSectionIds.locationSection,
    columnThree: mainAppSectionIds.sampleSection,
    columnFour: null,
  },
  locationInfoFocused: {
    orientation: "RIGHT",
    columnOne: null,
    columnTwo: null,
    columnThree: mainAppSectionIds.sampleSection,
    columnFour: mainAppSectionIds.locationInfoSection,
  },
  resultFocused: {
    orientation: "RIGHT",
    columnOne: null,
    columnTwo: null,
    columnThree: mainAppSectionIds.sampleSection,
    columnFour: mainAppSectionIds.resultsSection,
  },
  addNewLocationFocused: {
    orientation: "CENTER",
    columnOne: null,
    columnTwo: mainAppSectionIds.locationSection,
    columnThree: mainAppSectionIds.addNewLocationSection,
    columnFour: null,
  },
  mapFocused: {
    orientation: "LEFT",
    columnOne: mainAppSectionIds.mapSection,
    columnTwo: mainAppSectionIds.locationSection,
    columnThree: null,
    columnFour: null,
  },
};

// viewIds represent the identifiers of various view components
const viewIds = {
  startPage: "START_PAGE",
  newStudy: "NEW_STUDY", // Page for starting a new exam
  loadStudy: "LOAD_STUDY", // Page for loading a previous exam
  loadParticipantReview: "LOAD_PARTICIPANT_REVIEW", // Page for loading participant studies for review
  mainApp: "MAIN_APP", // Main app
  reviewMode: "REVIEW", // Review a participant's studies
  customProtocol: "CUSTOM_PROTOCOL", // Create custom protocol for new study
  loginPage: "LOGIN_PAGE", // User login page
};

// componentMap maps viewIds to corresponding components
const componentMap = {
  [viewIds.startPage]: StartPage,
  [viewIds.newStudy]: NewStudy,
  [viewIds.loadStudy]: LoadStudy,
  [viewIds.loadParticipantReview]: LoadParticipantReview,
  [viewIds.mainApp]: MainApp,
  [viewIds.reviewMode]: Review,
  [viewIds.customProtocol]: CreateCustomProtocol,
  [viewIds.loginPage]: LoginPage,
};

export {
  componentMap,
  viewIds,
  mainAppSectionIds,
  mainViewSectionCombinations,
};
